import { API_ENDPOINTS } from "@/api/services/profile/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const otherDocumentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOtherDocumentDetails: builder.query({
      query: () => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.GET_DOCUMENT_DETAILS,
        method: "GET",
      }),
      providesTags: [{ type: "documentDetails", id: "LIST" }],
    }),

    updateDocument: builder.mutation({
      query: (formdata) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.UPDATE_DOCUMENT,
        method: "PUT",
        body: formdata,
      }),
      invalidatesTags: [{ type: "documentDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
    //API FOR HR
    hrGetOtherDocumentDetails: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.HR_GET_DOCUMENT_DETAILS(empId),
        method: "GET",
      }),
      providesTags: [{ type: "documentDetails", id: "LIST" }],
    }),

    hrUpdateDocument: builder.mutation({
      query: ({ empId, formdata }) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.HR_UPDATE_DOCUMENT(empId),
        method: "PUT",
        body: formdata,
      }),
      invalidatesTags: [{ type: "documentDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
    documentDownload: builder.query({
      query: ({ folder, file }) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.DOCUMENT_DOWNLOAD(folder, file),
        method: "GET",
        responseHandler: (response) => response.blob(), // ✅ Force blob
      }),
    }),
  }),
});

export const {
  useGetOtherDocumentDetailsQuery,
  useUpdateDocumentMutation,
  useHrGetOtherDocumentDetailsQuery,
  useHrUpdateDocumentMutation,
  useLazyDocumentDownloadQuery,
} = otherDocumentsApi;
